import "./hb-b.css";
import { html } from "lit-html";

//import hb from "../../../public/hb.svg";
const hb = new URL("../../../public/hb.svg", import.meta.url).href;

export default html`
    <picture
        class="relative ml-[-15%] mb-[-19%] w-full scale-[0.9] md:scale-[0.5]">
        <!--<img src="${hb}" class="hidden h-[200px] w-[200px]" />-->
        <svg
            class="drop-shadow-2xl"
            fill="silver"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24">
            <path
                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                transform="rotate(45 12 12)" />
        </svg>
    </picture>
    <section
        id="hb-b-qr"
        class="hidden absolute ml-[-10%] mt-[10%] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <img class="w-32" />
        <span
            class="absolute text-medium font-extralight bottom-[-5px] end-[-20px]">
            ℠
        </span>
    </section>
    <section id="hb-b-avatar" class="hidden absolute w-full h-full">
        <hb-avatar></hb-avatar>
    </section>
`;
